<template>
  <div class="container-fluid modern-world text-center">
    <p class="accroche" v-html="$t('landing_components.services_center.title')"></p>
    <div class="row">
      <card goto="hebergement"
            image="hebergement.svg"
            orientation="left"
            :text="$t('landing_components.services_center.cards.hosting.content')"
            :title="$t('landing_components.services_center.cards.hosting.title')"/>

      <card goto="hebergement"
            image="connectivite.svg"
            orientation="middle"
            :text="$t('landing_components.services_center.cards.connectivity.content')"
            :title="$t('landing_components.services_center.cards.connectivity.title')"/>

      <card goto="https://be-ys.cloud/"
            image="cloud.svg"
            orientation="right"
            :text="$t('landing_components.services_center.cards.cloud.content')"
            :title="$t('landing_components.services_center.cards.cloud.title')"/>
    </div>
  </div>
</template>

<script>
import card from "@/components/generic/card";

export default {
  components: {card}
}
</script>

<style scoped>

.modern-world {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.9)), url('/images/bg2.webp');
  padding: 100px 0 100px;
}

.modern-world .accroche {
  padding-bottom: 50px;
  color: #f7f7f7;
}

.modern-world .row {
  width: 90%;
  margin: 0 auto;
}

</style>